import { combineReducers } from "redux";
import getOne from "./get-one";
import newAnswersQuiz from "./new-answer-quiz";

const quiz = combineReducers({
  getOne,
  newAnswersQuiz,
});

export default quiz;
